import { useAuth } from './useAuth';

/** Client-side permission display helper.
 *  The backend is authoritative — these checks only control UI visibility. */
export function usePermission() {
  const { isAdmin, isSuperAdmin, adminRole } = useAuth();

  return {
    /** Can view the review center */
    canReview: isAdmin && (adminRole === 'ops_reviewer' || adminRole === 'ops_admin' || adminRole === 'super_admin'),
    /** Can manage user accounts */
    canManageAccounts: isAdmin,
    /** Can manage admin accounts (super_admin only) */
    canManageAdminAccounts: isSuperAdmin,
    /** Can view audit logs */
    canViewAuditLogs: isAdmin && (adminRole === 'ops_admin' || adminRole === 'super_admin'),
    /** Can view/manage domain events */
    canManageDomainEvents: isAdmin && (adminRole === 'ops_admin' || adminRole === 'super_admin'),
    /** Can view analytics-oriented operations pages */
    canViewAnalytics: isAdmin && (adminRole === 'ops_reviewer' || adminRole === 'ops_admin' || adminRole === 'super_admin'),
    /** Can manage review reason templates */
    canManageReviewTemplates: isAdmin && (adminRole === 'ops_admin' || adminRole === 'super_admin'),
    /** Super admin unrestricted access */
    isSuperAdmin,
  };
}
